import colors from "@/data/color/color.data";
import faullpageOptions from "@/data/fullpage-options";

const state = {
  text: colors,
  carSliderIndex: 0,
  carSlider: {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    }
  },
  seatSlider: {
    loop: true
  },
  mainSlider: {
    loop: true
  },
  galleryMainSliderActiveIndex: 0,
  galleryMainSlider: {
    slidesPerView: 1,
    simulateTouch: false,
    followFinger: false,
    allowTouchMove: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    }
  },
  gallerySlider: {
    slidesPerView: 3,
    centeredSlides: true,
    spaceBetween: 30,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  },
  options: faullpageOptions
};

const getters = {
  color: (state: {}) => {
    return state;
  }
};

const mutations = {
  changeCarSliderPage(state: any, payload: number) {
    state.carSliderIndex = payload;
  },
  changeGallerySliderPage(state: any, payload: number) {
    state.galleryMainSliderActiveIndex = payload;
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
